import type { StreamContribution } from '@wehunt/app-shell-web'
import { buildOutfitterRoutes } from './routes'

/**
 * Outfitter stream's contribution to the WeHunt web shell.
 *
 * Outfitter owns the commercial transaction: subscriptions, entitlement
 * purchase, orders, warranties, and anything that produces an invoice —
 * regardless of who ends up receiving the money. Viltrapport killing fees
 * are invoiced to hunt-area members and paid onward to the area rather
 * than to Natlink, and they are still Outfitter's, because the machinery
 * that prices, issues and reconciles an invoice is the same either way.
 * The line against Estate is domain vs transaction, not payee: Estate
 * decides who holds which land right, Outfitter charges for it.
 *
 * It contributes routes only. The Account section's shop entries
 * (Dashboard … Wallet) are links into the web shop, composed by the app
 * shell from runtime config rather than contributed by a stream, because
 * they leave this app; Settings stays with clubhouse, which owns that route.
 */
export const outfitterContribution: StreamContribution = {
  id: 'outfitter',
  routes: buildOutfitterRoutes,
  nav: {
    account: [],
  },
}
